// @module Ames.RentFromAnywhere.RentFromAnywhere
define("Ames.RentFromAnywhere.RentFromAnywhere.View", [
  "ames_rentfromanywhere_rentfromanywhere.tpl",

  "Ames.RentFromAnywhere.RentFromAnywhere.SS2Model",

  "Backbone",
  "LiveOrder.Model",
  "Item.Model",
  "Utils",
], function (
  ames_rentfromanywhere_rentfromanywhere_tpl,

  RentFromAnywhereSS2Model,

  Backbone,
  LiveOrderModel,
  ItemModel,
  Utils
) {
  "use strict";

  var PERIODS = {
    "8-day":   { days: 8,  label: "8 Days Rental",  rateField: "custitem_nst_rrm_rt_daily",   rateId: "custitem_nst_rrm_rt_daily" },
    "16-days": { days: 16, label: "16 Days Rental", rateField: "custitem_nst_rrm_rt_weekly",  rateId: "custitem_nst_rrm_rt_weekly" },
    "30-days": { days: 30, label: "30 Days Rental", rateField: "custitem_nst_rrm_rt_monthly", rateId: "custitem_nst_rrm_rt_monthly" },
    "60-days": { days: 60, label: "60 Days Rental", rateField: "custitem_nst_rrm_60_days",    rateId: "custitem_nst_rrm_60_days" },
    "90-days": { days: 90, label: "90 Days Rental", rateField: "custitem_nst_rrm_90_days",    rateId: "custitem_nst_rrm_90_days" }
  };

  var DEFAULT_PERIOD = "8-day";

  // @class Ames.RentFromAnywhere.RentFromAnywhere.View @extends Backbone.View
  return Backbone.View.extend({
    template: ames_rentfromanywhere_rentfromanywhere_tpl,

    initialize: function (options) {
      this.pdp = options.container.getComponent("PDP");
      this.cart = options.container.getComponent("Cart");
      this.layout = options.container.getComponent("Layout");
      this.itemInfo = this.pdp.getItemInfo();

      this.isRental =
        this.itemInfo &&
        this.itemInfo.item &&
        this.itemInfo.item.custitem_nst_rrm_rt_daily
          ? true
          : false;

      if (!this.isRental) {
        return;
      }

      var self = this;

      options.container.getLayout().once("afterAppendView", function () {
        self.pdp.setQuantity(2);
        self.pdp.setQuantity(1);
        
        $(".product-details-quantity-value").prop("disabled", true);
      });

      // Build period prices from config
      this.periodPrices = {};
      var item = this.itemInfo.item;

      Object.keys(PERIODS).forEach(function (key) {
        var cfg = PERIODS[key];
        var rate = item[cfg.rateField];

        self.periodPrices[key] = {
          price: rate,
          priceFormatted: Utils.formatCurrency(rate),
          selected: key === DEFAULT_PERIOD,
          description: cfg.label,
          total: Utils.formatCurrency(Math.round(rate * cfg.days * 100) / 100),
          rateId: cfg.rateId
        };
      });

      this.selectPeriod(DEFAULT_PERIOD);
    },

    events: {
      'click [data-action="add-rent-item"]': "addRentItem",
      'click [data-action="select-period"]': "onPeriodClick"
    },

    /**
     * Set the selected period and update PDP options.
     */
    selectPeriod: function (periodKey) {
      var self = this;
      var cfg = PERIODS[periodKey];
      if (!cfg) return;

      // Update selection state
      Object.keys(this.periodPrices).forEach(function (key) {
        self.periodPrices[key].selected = (key === periodKey);
      });

      var selected = this.periodPrices[periodKey];
      this.description = selected.description;
      this.customPrice = Math.round(selected.price * cfg.days * 100) / 100;

      // Update PDP options
      this.pdp.setOption("custcol_configurable_description", this.description);
      this.pdp.setOption("custcol_custom_price", this.customPrice.toString());
      this.pdp.setOption("custcol_custom_rate", selected.rateId);
    },

    /**
     * Handle click on a table row to select a period.
     */
    onPeriodClick: function (e) {
      var $row = this.$(e.currentTarget);
      var periodKey = $row.data("period");

      if (periodKey) {
        this.selectPeriod(periodKey);
        this.render();
      }
    },

    addRentItem: function (e) {
      e.preventDefault();

      var internalid = this.itemInfo.item.internalid;
      var self = this;
      var rentalPrice =
        this.customPrice ||
        this.itemInfo.item.onlinecustomerprice_detail.onlinecustomerprice;

      var qty = $("#quantity").val();

      var selectedKey = _.find(_.keys(self.periodPrices), function (key) {
        return self.periodPrices[key].selected;
      });

      var selectedRateId = selectedKey
        ? self.periodPrices[selectedKey].rateId
        : null;

      this.cart
        .addLine({
          line: {
            quantity: parseFloat(qty) || 1,
            item: { internalid: internalid },
            options: [
              {
                cartOptionId: "custcol_custom_price",
                value: {
                  internalid: rentalPrice.toString(),
                  label: rentalPrice.toString(),
                },
              },
              {
                cartOptionId: "custcol_configurable_description",
                value: {
                  internalid: self.description,
                  label: self.description,
                },
              },
              {
                cartOptionId: "custcol_custom_rate",
                value: {
                  internalid: selectedRateId,
                  label: selectedRateId,
                },
              },
            ],
          },
        })
        .done(function () {
          self.cart.triggerAddToCartConfirmation().then(function () {
            console.log("Add to cart confirmation was triggered.");
          });
        });
    },

    bindings: {},

    childViews: {},

    //@method getContext @return Ames.RentFromAnywhere.RentFromAnywhere.View.Context
    getContext: function getContext() {
      return {
        "8days": this.isRental ? this.periodPrices["8-day"] : null,
        "16days": this.isRental ? this.periodPrices["16-days"] : null,
        "30days": this.isRental ? this.periodPrices["30-days"] : null,
        "60days": this.isRental ? this.periodPrices["60-days"] : null,
        "90days": this.isRental ? this.periodPrices["90-days"] : null,
        isRental: this.isRental,
      };
    },
  });
});
